export enum ButtonMessage {
  COPYLINK = 'Copy link',
  COPY = 'Copy',
  COPYING = 'Copying',
  COPIED = 'Copied',
  ERROR = 'Error. Try again',
  BUTTONROLE = 'status',
}

export enum TrackingMessage {
  COPYLINK = 'copyArticleLink',
}
